import { getCurrentInstance, useNuxtApp } from '#imports';

const RECAPTCHA_SITE_KEY = '6LdzWqUpAAAAAJ2F2Gj-XHJ7rk5zk8B8eIeY8QYd';

type VueApp = ReturnType<typeof useNuxtApp>['vueApp'];

interface RecaptchaGlobalProperties {
  $recaptchaLoaded?: () => Promise<boolean>;
  $recaptcha?: (action: string) => Promise<string>;
}

let installPromise: Promise<void> | null = null;

/**
 * vue-recaptcha-v3 грузит скрипт Google в момент установки плагина, то есть раньше
 * это происходило на каждой странице (346 КБ на gstatic). Ставим плагин лениво,
 * при первой реальной попытке получить токен.
 */
const ensureRecaptcha = (vueApp: VueApp) => {
  if (!installPromise) {
    installPromise = import('vue-recaptcha-v3').then(({ VueReCaptcha }) => {
      vueApp.use(VueReCaptcha, {
        siteKey: RECAPTCHA_SITE_KEY,
        loaderOptions: {
          autoHideBadge: false,
          useRecaptchaNet: true,
          explicitRenderParameters: {
            badge: 'bottomleft',
            size: 'invisible',
          },
        },
      });
    });
  }

  return installPromise;
};

/**
 * Возвращает токен reCAPTCHA и заголовок для последующих запросов.
 * Плагин регистрируется при первом вызове, поэтому вызывать нужно только
 * в момент отправки формы, а не при монтировании.
 */
export default () => {
  const nuxtApp = useNuxtApp();
  const vm = getCurrentInstance();

  const executeRecaptcha = async (action: string) => {
    await ensureRecaptcha(nuxtApp.vueApp);

    const globalProperties = vm?.appContext.config.globalProperties as
      | RecaptchaGlobalProperties
      | undefined;

    await globalProperties?.$recaptchaLoaded?.();
    const token = await globalProperties?.$recaptcha?.(action);

    const headerOptions = {
      headers: {
        'google-recaptcha-token': token,
      },
    };

    return { token, headerOptions };
  };

  return { executeRecaptcha };
};
